import * as React from "react";
import { SVGProps } from "react";

const FileIcon = (props: SVGProps<SVGSVGElement>) => (
    <svg
        xmlns="http://www.w3.org/2000/svg"
        width={48}
        height={48}
        fill="none"
        {...props}
    >
        <path
            fill="#3871FB"
            d="M6.6 7.8a3 3 0 0 1 3-3h19.8a3 3 0 0 1 3 3v28.2a3 3 0 0 1-3 3H9.6a3 3 0 0 1-3-3V7.8Z"
        />
        <rect width={16.2} height={2.4} x={10.8} y={15.6} fill="#fff" rx={1.2} />
        <rect width={16.2} height={2.4} x={10.8} y={20.4} fill="#fff" rx={1.2} />
        <foreignObject width={29.4} height={37.2} x={16.8} y={9}>
            <div
                style={{
                    backdropFilter: "blur(2px)",
                    clipPath: "url(#a)",
                    height: "100%",
                    width: "100%",
                }}
            />
        </foreignObject>
        <g data-figma-bg-blur-radius={4} filter="url(#b)">
            <rect
                width={24.6}
                height={32.4}
                x={19.2}
                y={11.4}
                fill="#0085FF"
                fillOpacity={0.19}
                rx={2.4}
            />
        </g>
        <rect width={16.2} height={2.4} x={22.8} y={29.016} fill="#fff" rx={1.2} />
        <rect width={16.2} height={2.4} x={22.8} y={34.916} fill="#fff" rx={1.2} />
        <defs>
            <clipPath id="a" transform="translate(-16.8 -9)">
                <rect width={24.6} height={32.4} x={19.2} y={11.4} rx={2.4} />
            </clipPath>
            <filter
                id="b"
                width={29.4}
                height={37.2}
                x={16.8}
                y={9}
                colorInterpolationFilters="sRGB"
                filterUnits="userSpaceOnUse"
            >
                <feFlood floodOpacity={0} result="BackgroundImageFix" />
                <feBlend in="SourceGraphic" in2="BackgroundImageFix" result="shape" />
                <feColorMatrix
                    in="SourceAlpha"
                    result="hardAlpha"
                    values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
                />
                <feOffset dx={0.12} dy={0.06} />
                <feGaussianBlur stdDeviation={0.3} />
                <feComposite in2="hardAlpha" k2={-1} k3={1} operator="arithmetic" />
                <feColorMatrix values="0 0 0 0 1 0 0 0 0 1 0 0 0 0 1 0 0 0 1 0" />
                <feBlend in2="shape" result="effect1_innerShadow_10912_1353" />
            </filter>
        </defs>
    </svg>
);

export default FileIcon;
